import React from 'react';
import { Redirect } from 'react-router-dom';

import { ApplicationWrapper, AuthType } from '@innovyze/stylovyze';
import { usePageRoutes } from '@Pages';
import EmbedHeaderHider from './embed/EmbedHeaderHider';
import EmbedRouteGuard from './embed/EmbedRouteGuard';
import BernoulliHome from './pages/BernoulliHome/BernoulliHome';

function withRootRedirect(pages: ReturnType<typeof usePageRoutes>) {
  const [{ to: firstRoute } = { to: '' }] = pages;
  if (!firstRoute) return pages;
  return [...pages, { to: '/', render: <Redirect to={firstRoute} /> }];
}

function EmbedPage() {
  const isIframeEmbed = window.self !== window.top;

  return (
    <>
      <EmbedHeaderHider />
      {isIframeEmbed ? <EmbedRouteGuard /> : null}
      <BernoulliHome embeddedInHost />
    </>
  );
}

const EMBED_PAGES = [
  {
    to: '/embed',
    render: <EmbedPage />,
  },
];

type ApplicationWrapperProps = React.ComponentProps<typeof ApplicationWrapper>;

function App() {
  const pages = withRootRedirect(usePageRoutes());
  const isEmbedRoute = window.location.pathname.startsWith('/embed');
  const isIframeEmbed = isEmbedRoute && window.self !== window.top;

  if (isEmbedRoute) {
    const embedProps: ApplicationWrapperProps = isIframeEmbed
      ? {
          pages: EMBED_PAGES,
          // Boolean true keeps LOGIN_V2 routes without short-circuiting ForgeAuthenticationGate
          // to ForgeProvider (AuthType.Forge string bypasses enableAuthStage → signin-stg).
          // Must not be false: legacy AuthenticationRouter mounts Auth0 sign-in in iframe.
          loginPicker: true,
          showSideNav: false,
          authenticate: false,
          validateTerms: false,
          isTenantAware: false,
          // Skip Forge/Auth0 shared workers — they load signin-stg webSdkIframe (blocked in Model).
          hasSharedWorkers: false,
        }
      : {
          pages: EMBED_PAGES,
          loginPicker: AuthType.Forge,
          showSideNav: false,
        };

    return <ApplicationWrapper {...embedProps} />;
  }

  return <ApplicationWrapper pages={pages} loginPicker={AuthType.Forge} />;
}

export default App;
